import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 *
 * @class
 * MapOverlayComponent
 *
 * @description
 * This component is an overlay for the map component.
 *
 */
@Component({
  templateUrl: './map-overlay.component.html',
  selector: 'map-overlay',
  styleUrls: ['./map-overlay.component.scss']
})
export class MapOverlayComponent {
  @Input() text: string;
  @Input() hasClose: boolean;
  @Output() close = new EventEmitter();

  public closeOverlay(): void {
    this.close.emit(null);
  }

}